import { ReactNode, useEffect, useState } from 'react';

import { useGetBrandingQuery } from '../../lendingApi/lendingApiQueries';

type TProps = {
  children: ReactNode;
};

const Branding = ({ children }: TProps) => {
  const { branding } = useGetBrandingQuery();

  const [customProperties, setCustomProperties] = useState<Array<string>>([]);

  useEffect(() => {
    let colour_map: Record<string, string | undefined | null> = {};

    const body = document.getElementsByTagName('body')[0];

    for (const customProperty of customProperties) {
      body.style.removeProperty(customProperty);
      setCustomProperties([]);
    }

    if (branding && branding.signup_branding_type === 'partner') {
      const {
        primary_colour,
        secondary_colour,
        title_colour,
        primary_theme,
        secondary_theme,
      } = branding.data;

      colour_map = {
        '--color-primary': primary_colour,
        '--color-title': title_colour || primary_colour,
        '--color-secondary': secondary_colour,
        '--theme-primary': primary_theme === 'light' ? '#333' : '#FFF',
        '--theme-secondary': secondary_theme === 'light' ? '#333' : '#FFF',
      };
    } else {
      colour_map = {
        '--color-primary': 'var(--color-primary-10)',
        '--color-primary-darker': 'var(--color-primary-20)',
        '--color-sidebar': 'var(--color-primary-10)',
      };
    }

    const propertyNames = [];
    for (const [variableName, variableValue] of Object.entries(colour_map)) {
      if (!variableValue) continue;
      propertyNames.push(variableName);

      body.style.setProperty(variableName, variableValue);
    }
    setCustomProperties(propertyNames);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branding]);

  return <>{children}</>;
};

export default Branding;
